// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2WAuR","info":"Note_info__1xKI3","note":"Note_note__2qWud","actions":"Note_actions__1YQT9"};